import { render } from "./SnippetSocialIcons.vue?vue&type=template&id=77caa584"
import script from "./SnippetSocialIcons.vue?vue&type=script&lang=js"
export * from "./SnippetSocialIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__